var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaptureFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.10267 8.23333C8.86265 8.61321 8.54243 8.93598 8.16445 9.17898C7.78647 9.42198 7.3599 9.57933 6.91467 9.64C6.408 9.712 5.90533 9.78933 5.40267 9.87333C3.99867 10.1067 3 11.3427 3 12.7653V24C3 24.7956 3.31607 25.5587 3.87868 26.1213C4.44129 26.6839 5.20435 27 6 27H26C26.7957 27 27.5587 26.6839 28.1213 26.1213C28.6839 25.5587 29 24.7956 29 24V12.7653C29 11.3427 28 10.1067 26.5973 9.87333C26.0943 9.78952 25.5902 9.71173 25.0853 9.64C24.6403 9.57915 24.214 9.42171 23.8363 9.17871C23.4586 8.93572 23.1385 8.61306 22.8987 8.23333L21.8027 6.47867C21.5565 6.0788 21.2176 5.74412 20.8147 5.50298C20.4118 5.26184 19.9567 5.12132 19.488 5.09333C17.1643 4.96852 14.8357 4.96852 12.512 5.09333C12.0433 5.12132 11.5882 5.26184 11.1853 5.50298C10.7824 5.74412 10.4435 6.0788 10.1973 6.47867L9.10267 8.23333Z",
    stroke: "#662B5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.25 17C21.25 18.3924 20.6969 19.7277 19.7123 20.7123C18.7277 21.6969 17.3924 22.25 16 22.25C14.6076 22.25 13.2723 21.6969 12.2877 20.7123C11.3031 19.7277 10.75 18.3924 10.75 17C10.75 15.6076 11.3031 14.2723 12.2877 13.2877C13.2723 12.3031 14.6076 11.75 16 11.75C17.3924 11.75 18.7277 12.3031 19.7123 13.2877C20.6969 14.2723 21.25 15.6076 21.25 17Z",
    stroke: "#662B5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 14H25.0112V14.0112H25V14Z",
    fill: "#D9D9D9",
    stroke: "#662B5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureFrame);
export default __webpack_public_path__ + "static/media/CaptureFrame.4c960695a3bd2829c6849fb485e893a0.svg";
export { ForwardRef as ReactComponent };